import { useEffect, useCallback, useState, useRef } from "react";
import { Native } from "../../platform/android/nativeBridge";
import { APP_METHODS, NATIVE_EVENTS } from "../../platform/android/nativeMethods";
import { onNativeEvent } from "../../platform/android/nativeEventBus";
import { IoLocationOutline } from "react-icons/io5";
import Button from "../../components/Button";
import Modal from "../../components/Modal";
import { parseNativeResponse } from "../../utils/ParseNativeResponse";
import useAppStore from "../../store/useAppStore";
import "./EnableGpsLocation.scss";

export default function EnableGpsLocation() {
  const [isOpen, setIsOpen] = useState(false);
  const wasModalShowing = useRef(false);

  const updateGpsState = useCallback((isEnabled) => {
    setIsOpen(!isEnabled);

    if (isEnabled && wasModalShowing.current) {
      const unsubscribeLocationEvent = onNativeEvent(
        NATIVE_EVENTS.GET_LOCATION_DETAILS_RESULTS,
        (data) => {
          unsubscribeLocationEvent();
          useAppStore.getState().storeLocationDetails(parseNativeResponse(data?.data ?? data));
        }
      );
      Native.send(APP_METHODS.FETCH_LOCATION_DETAILS);
    }

    wasModalShowing.current = !isEnabled;
  }, []);

  const checkGpsStatus = useCallback(async () => {
    if (!Native.isApp) return;
    const result = await Native.send(APP_METHODS.CHECK_GPS_STATUS);
    const parsed = parseNativeResponse(result);
    const isEnabled = [true, "true"].includes(parsed?.success ?? parsed);
    updateGpsState(isEnabled);
  }, [updateGpsState]);

  useEffect(() => {
    checkGpsStatus();

    // Listen for push events directly from the Native App (BroadcastReceiver)
    const unsubscribeNativeGpsEvent = onNativeEvent(NATIVE_EVENTS.GPS_STATUS_CHANGED, (data) => {
      const parsedData = parseNativeResponse(data?.data ?? data);
      const isEnabled = [true, "true"].includes(parsedData?.success ?? parsedData);
      updateGpsState(isEnabled);
    });

    return () => {
      unsubscribeNativeGpsEvent();
    };
  }, [checkGpsStatus, updateGpsState]);

  const handleTurnOnLocation = () => {
    if (Native.isApp) {
      Native.send(APP_METHODS.OPEN_GPS_SETTINGS);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      showCloseButton={false}
      closeOnBackdropClick={false}
      isBottomSheet={true}
      enableSwipeToClose={false}
      isPermissionModal={true}
    >
      <div className="enable-location-modal-content">
        <IoLocationOutline className="gps-icon" />

        <h2 className="heading">Turn on Location Services</h2>

        <p className="description">
          Go to Settings &rarr; Privacy &amp; Security &rarr; <br /> Location Services and turn it
          on to continue.
        </p>

        <Button onClick={handleTurnOnLocation}>Turn on</Button>
      </div>
    </Modal>
  );
}
